import { useState, useEffect } from 'react';
import { resolveB2Url } from '../api/storageResolver';

const PALETTE = [
  '#5B4E8A', // dusty purple
  '#7A5C3C', // warm brown
  '#4A6741', // forest green
  '#5A6E8A', // slate blue
  '#8A4A5A', // dusty rose
  '#4A8A7A', // teal
  '#8A6A3A', // caramel
  '#6B5A9E', // medium purple
  '#6B7A4A', // olive
  '#8A4A6B', // mauve
  '#3A6A7A', // deep teal
  '#7A3A4A', // wine
];

function titleHash(str) {
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = (h * 31 + str.charCodeAt(i)) & 0x7fffffff;
  }
  return h;
}

const ASPECT = { '1:1': '1/1', '2:3': '2/3', '16:9': '16/9' };
const WIDTH  = { sm: 96, md: 160, lg: 240 };

export default function MediaCover({ item, aspectRatio = '1:1', onClick, size = 'md' }) {
  const coverUri    = item?.CoverImageUrl || '';
  const hasCover    = coverUri.startsWith('b2://');
  const hasThumbnail = !hasCover && !!item?.thumbnailUrl;

  const [imgSrc, setImgSrc]     = useState(null);
  const [imgStatus, setImgStatus] = useState('idle'); // idle | loading | ready | error

  useEffect(() => {
    if (!hasCover) {
      setImgSrc(null);
      setImgStatus('idle');
      return;
    }
    let cancelled = false;
    setImgStatus('loading');
    resolveB2Url(coverUri)
      .then(url => { if (!cancelled) { setImgSrc(url); setImgStatus('ready'); } })
      .catch(() => { if (!cancelled) setImgStatus('error'); });
    return () => { cancelled = true; };
  }, [coverUri, hasCover]);

  const title = item?.Title || '';
  const bg    = PALETTE[titleHash(title) % PALETTE.length];
  const cardStyle = {
    width: `${WIDTH[size] ?? WIDTH.md}px`,
    aspectRatio: ASPECT[aspectRatio] ?? ASPECT['1:1'],
  };

  const clickClass = onClick ? ' fv-cover-card--clickable' : '';

  if (hasThumbnail) {
    return (
      <div className={`fv-cover-card${clickClass}`} style={cardStyle} onClick={onClick}>
        <img
          className="fv-cover-img"
          src={item.thumbnailUrl}
          alt={title}
        />
      </div>
    );
  }

  if (hasCover && imgStatus === 'loading') {
    return (
      <div
        className={`fv-cover-card fv-cover-skeleton${clickClass}`}
        style={cardStyle}
        onClick={onClick}
      />
    );
  }

  if (hasCover && imgStatus === 'ready') {
    return (
      <div className={`fv-cover-card${clickClass}`} style={cardStyle} onClick={onClick}>
        <img
          className="fv-cover-img"
          src={imgSrc}
          alt={title}
          onError={() => setImgStatus('error')}
        />
      </div>
    );
  }

  return (
    <div
      className={`fv-cover-card fv-cover-fallback${clickClass}`}
      style={{ ...cardStyle, backgroundColor: bg }}
      onClick={onClick}
    >
      <span className="fv-cover-fallback-title">{title}</span>
    </div>
  );
}
